import SvgIcon from "../SvgIcon";

import styles from "./index.module.scss";

interface ICounterProps {
  value: string;
  valueKey?: string;
  errorMessage?: string;
  min?: number;
  max?: number;
  onChange: ({ value, valueKey }: { value: string; valueKey?: string }) => void;
}

function Counter({
  value,
  onChange,
  valueKey = "",
  errorMessage = "",
  min = 0,
  max = undefined,
}: ICounterProps) {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange({ value: e.target.value, valueKey });
  };

  const handleButtonClick = (action: "increase" | "decrease") => () => {
    let newValue = +value;

    switch (action) {
      case "increase": {
        newValue += 1;
        break;
      }

      default: {
        newValue -= 1;
        break;
      }
    }

    onChange({ value: `${newValue}`, valueKey });
  };

  return (
    <div className={styles.container}>
      <div className={styles.fieldContainer}>
        <button
          className={styles.button}
          onClick={handleButtonClick("decrease")}>
          <SvgIcon type="FiMinus" />
        </button>

        <input
          className={styles.input}
          type="number"
          value={value}
          min={min}
          max={max}
          onChange={handleChange}
        />

        <button
          className={styles.button}
          onClick={handleButtonClick("increase")}>
          <SvgIcon type="FiPlus" />
        </button>
      </div>

      <span className={styles.error}>{errorMessage}</span>
    </div>
  );
}

export default Counter;
